import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { withStyles } from 'material-ui/styles';
import withAppStore from 'decorators/withAppStore';
import styles from 'styles/components/CodeInfo';
import ToDateNotificator from 'components/ToDateNotificator';
import Code from 'components/Code';
import { formatOrder } from 'components/CodeInfo';
import CodeInfoSection from 'components/CodeInfoSection';

@withStyles(styles)
@withAppStore
@observer
export default class CodeInfoCertification extends Component {
    render() {
        const { cert } = this.props;
        const summary = getTitleSummary(cert.certifications)
        return (
            <CodeInfoSection key={cert.id}
                expanded={false}
                title={
                    {
                        headers: [cert.full_name],
                        rows: summary
                    }}
                table={{
                    headers: [
                        '',
                        'Код',
                        'Описание товара',
                        'Наличие',
                        'Наименование перечня',
                        'Документы, которыми сопровождаются товары',
                        'Нормативный документ',
                        'Разрешение на ввоз',
                        'Реестр предприятий третьих стран',
                        'Примечание'
                    ],
                    rows: cert.certifications.map(({
                        to_date = null,
                        code = '',
                        description = '',
                        type,
                        reestr = '',
                        required_documents = '',
                        order, order_date, orders_info = null,
                        in_perm_required = '',
                        th_patry_org_reestr = '',
                        note = ''
                    }) => ([
                        <ToDateNotificator to_date={to_date} />,
                        <Code code={code} />,
                        description,
                        type === 2 ? 'Требуется' : 'Нет, см. примечание',
                        reestr,
                        required_documents,
                        formatOrder(order, order_date, orders_info),
                        in_perm_required,
                        th_patry_org_reestr,
                        note
                    ]))
                }}
            />
        )
    }
}

function getTitleSummary(items) {
    if (items.length === 0) {
        return null
    }
    var result = []
    items.filter(function (item) { return item.type === 2 }).forEach(item => {
        if (result.length === 0) {
            result.push(item);
        }
        else if (!(result.find((element) => element.reestr === item.reestr))) {
            result.push(item);
        }
    })
    return result.length !== 0 ? result.map(({
        reestr = '',
        order, order_date, orders_info = null,
    }) => ([
        `${reestr}`,
        formatOrder(order, order_date, orders_info),
    ])) : items.slice(0, 1).map(({
        reestr = '',
        order, order_date, orders_info = null,
    }) => ([
        `${reestr}`,
        formatOrder(order, order_date, orders_info),
    ]))

}




// WEBPACK FOOTER //
// ./src/components/codeinfo/CodeInfoCertification.js